import React from "react";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import { Link, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

const Contact = () => {
  const history = useNavigate();

  return (
    <Container maxWidth="sm xs lg" className="main-bg4">
      <Grid container spacing={3}>
        <Grid item xs sm lg>
          <img src="images/chat.png" width="45%" />
        </Grid>

        <Grid item sm>
          <Box className="main-title4">
            <p className="text-main4">Ponte en Contacto con Nosotros</p>
            <p className="subtext-main4">
              ¿Tienes alguna pregunta o comentario?
              <br />
              Contáctanos y uno de nuestros representantes
              <br />
              te responderá lo antes posible.
              <br />
              <br />
              Estamos aquí para ayudarte.
            </p>
            <Button
              type="submit"
              variant="contained"
              color="success"
              size="large"
              sx={{ backgroundColor: "#27cd11" }}
              onClick={() => history("/ayuda")}
            >
              preguntas frecuentes
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Contact;
